import './FrameworkCard.css';

import React from 'react';
import { fullImagePath, generateClassName } from '../../b2b-common/helpers';
import { InsightsOutlined, LooksOne } from '@mui/icons-material';

const FrameworkCard = ({ framework, className=null }) => {
    return (
        <div className={generateClassName('framework-card','',className)}>
            <img className="framework-image" src={fullImagePath(framework.imagePath)} alt={framework.frameworkName} />
            {framework.hasSecondaryFrameworks ? (
                <div className='framework-secondary'>
                    {framework.hasSecondaryFrameworks &&
                        <div title="Has secondary framework">
                            <LooksOne />
                        </div>
                    }
                </div>) : null}
            {framework.hasNonStandardLevelNs ? (
                <div className='framework-non-standard'>
                    {framework.hasNonStandardLevelNs &&
                        <div title="May have custom indicators">
                            <InsightsOutlined />
                        </div>
                    }
                </div>
            ) : null}
            <div className="framework-name">{framework.frameworkName}</div>
        </div>
    );
};

export default FrameworkCard;